import * as api from "../../shared/api"
import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = ""

const create = function () {
  return {
    content_type: "muji",
    age: 29
  }
}
const descriptor = {}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)

const fields = {
  route_cost: [
    { key: 'OprId', label: '工序', sortable: true },
    { key: 'OprNum', label: '上一道工序', sortable: true },
    { key: 'OprNumNext', label: '下一个', sortable: true },
    { key: 'TEC_ColorNumber', label: '色组数', sortable: true },
    { key: 'TEC_VariantParameters', label: '变化参数', sortable: true },
    { key: 'TEC_AccuVariantParameters', label: '累计变化参数', sortable: true },
    { key: 'TEC_PartsCoefficient', label: '部件系数', sortable: true },
    { key: 'TEC_DifficultyFactor', label: '难度系数', sortable: true },
    { key: 'TEC_RouteType', label: '工序类型', sortable: true },
    { key: 'SpoilageBaseNumber', label: '加放基数', sortable: true },
    { key: 'SpoilageRate', label: '加放率', sortable: true },
    { key: 'RouteJustQty', label: '工序正数', sortable: true },
    { key: 'SpoilageQty', label: '加放', sortable: true },
    { key: 'AddQty', label: '续加', sortable: true },
    { key: 'RealQtyRate', label: '实物加放率', sortable: true },
    { key: 'RealQty', label: '实物投入', sortable: true },
  ],
  qt_detail: [
    { key: 'QuotationTaskNum', label: '报价申请编号', sortable: true },
    { key: 'LineNum', label: '行号', sortable: true },
    { key: 'CustAccount', label: '客户账户', sortable: true },
    {
      key: 'CustName', label: '客户名称', sortable: true, type: "short",
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: "dataAreaId",
      label: "销售公司",
      sortable: true,
      thStyle: {
        width: "5rem"
      }
    },
    {
      key: "CompanyName",
      label: "销售公司名称",
      sortable: true,
      thStyle: { width: "8rem" },
      width: "8rem",
      type: "short"
    },
    { key: 'ItemId', label: '物料编号', sortable: true },
    {
      key: 'NameAlias', label: '物料名称', sortable: true, type: "textarea",
      thStyle: {
        width: "12rem"
      }
    },
    { key: 'FromBatchQty', label: '起始数量', sortable: true, type: "number", },
    { key: 'BatchQty', label: '结束数量', sortable: true, type: "number", },
    {
      key: 'IsHomemade', label: '是否接受外协', sortable: true, formatter: (value, key, item) => {
        if (item.IsHomemade == 1) return "是"
        else if (item.IsHomemade == 2) return "纯外协"
        else return "否"
      }
    },
    { key: 'Price', label: '申请报价', sortable: true, type: "just_number", },
    {
      key: 'InclTax', label: '价格是否含税', sortable: true, thStyle: {
        width: "8rem"
      }
    },
    {
      key: 'Description', label: '描述', sortable: true, type: "textarea",
      thStyle: { width: "12rem" }
    },

  ],
  qt_all_ok_detail: [
    { key: 'QuotationTaskNum', label: '报价申请编号', sortable: true, thStyle: { width: "8rem" } },
    {
      key: "CustAccount",
      label: "客户账户",
      sortable: true,
      thStyle: {
        width: "5rem"
      }
    },
    {
      key: "CustName",
      label: "客户名称",
      sortable: true,
      thStyle: { width: "10rem" }
    },
    { key: "dataAreaId", label: "销售公司", sortable: true, thStyle: { width: "5rem" } },
    {
      key: "CompanyName",
      label: "销售公司名称",
      sortable: true,
      thStyle: { width: "10rem" },
      type: "short"
    },
    { key: 'LineNum', label: '行号', sortable: true },
    { key: 'ItemId', label: '物料编号', sortable: true },
    { key: 'NameAlias', label: '物料名称', sortable: true, type: "textarea", thStyle: { width: "12rem" } },
    { key: 'FromBatchQty', label: '起始数量', sortable: true, type: "number", },
    { key: 'BatchQty', label: '结束数量', sortable: true, type: "number", },
    {
      key: 'IsHomemade', label: '是否接受外协', sortable: true, thStyle: { width: "6rem" },
      formatter: (value, key, item) => {
        if (item.IsHomemade == 1) return "是"
        else if (item.IsHomemade == 2) return "纯外协"
        else return "否"
      }
    },
    { key: 'Price', label: '申请报价', sortable: true, type: "just_number", },
    {
      key: 'InclTax', label: '价格是否含税', sortable: true, thStyle: { width: "8rem" }
    },
    { key: 'DeliveryAddress', label: '交货地址', sortable: true },
    { key: 'DeliveryMode', label: '运输方式', sortable: true },
    { key: 'DemandDate', label: '预计需求日期', sortable: true, type: "date", thStyle: { width: "6rem" } },
    { key: 'DayDemandQty', label: '日需求量', sortable: true, type: "just_number" },
    {
      key: 'Description', label: '描述', sortable: true, type: "textarea",
      thStyle: { width: "12rem" }
    },
    { key: 'create_by_username', label: '申请创建人', sortable: true },
    {
      key: 'closed',
      label: '关闭状态',
      type: 'state_closed',
      context: ["正常", "待关闭", "已关闭"]
    },
    {
      key: "IsAllApprovedOk",
      label: "审批",
      sortable: true,
      type: "state",
      state_control: "IsAllApprovedOk",
      other_type_key: "is_weightcost_refused",
      context: ["待审批", "已审批", "已退回"]
    },
    {
      key: 'ApproveRemark', label: '审批意见', sortable: true, type: 'html',
      thStyle: { width: "12rem" },
    }
  ],
  qt_all_ok_detail_pro: [
    { key: 'QuotationTaskNum', label: '报价申请编号', sortable: true, thStyle: { width: "8rem" } },
    {
      key: "CustAccount",
      label: "客户账户",
      sortable: true,
      thStyle: {
        width: "5rem"
      }
    },
    {
      key: "CustName",
      label: "客户名称",
      sortable: true,
      thStyle: { width: "10rem" }
    },
    { key: "dataAreaId", label: "销售公司", sortable: true, thStyle: { width: "5rem" } },
    {
      key: "CompanyName",
      label: "销售公司名称",
      sortable: true,
      thStyle: { width: "10rem" },
      type: "short"
    },
    { key: 'LineNum', label: '行号', sortable: true },
    { key: 'ItemId', label: '物料编号', sortable: true },
    { key: 'NameAlias', label: '物料名称', sortable: true, type: "textarea", thStyle: { width: "12rem" } },
    { key: 'FromBatchQty', label: '起始数量', sortable: true, type: "number", },
    { key: 'BatchQty', label: '结束数量', sortable: true, type: "number", },
    {
      key: 'IsHomemade', label: '是否接受外协', sortable: true, thStyle: { width: "6rem" },
      formatter: (value, key, item) => {
        if (item.IsHomemade == 1) return "是"
        else if (item.IsHomemade == 2) return "纯外协"
        else return "否"
      }
    },
    { key: 'Price', label: '申请报价', sortable: true, type: "just_number", },
    {
      key: 'InclTax', label: '价格是否含税', sortable: true, thStyle: { width: "8rem" }
    },
    { key: 'DeliveryAddress', label: '交货地址', sortable: true },
    { key: 'DeliveryMode', label: '运输方式', sortable: true },
    { key: 'DemandDate', label: '预计需求日期', sortable: true, type: "date", thStyle: { width: "6rem" } },
    { key: 'DayDemandQty', label: '日需求量', sortable: true, type: "just_number" },
    {
      key: 'Description', label: '描述', sortable: true, type: "textarea",
      thStyle: { width: "12rem" }
    },
    { key: 'create_by_username', label: '申请创建人', sortable: true },
    {
      key: 'Accessory',
      label: '附件',
      type: "button",
      button: {
        type: "text",
        icon_class: "iconfont icon-fujian",
        label: "",
        show_label: true
      },
      thStyle: { width: "70px" }
    },
    {
      key: 'closed',
      label: '关闭状态',
      type: 'state_closed',
      context: ["正常", "待关闭", "已关闭"]
    },
    {
      key: 'ConsultDescription', label: '重新询价备注', sortable: true, type: "textarea",
      thStyle: { width: "12rem" }
    },
    { key: "is_proofing_confirm", label: "确认", type: "boolean" },
    { key: 'proofing_confirm_by_username', label: '确认人', sortable: true },
    {
      key: "proofing_confirm_at",
      label: "确认时间",
      type: "datetime",
      sortable: true,
      thStyle: {
        width: "180px"
      }
    }
  ],
  detail_cacl_fields: [
    {
      key: "AccountNum",
      label: "供应商编号",
      sortable: true,
      thStyle: {
        width: "5rem"
      }
    },
    {
      key: "AccountName",
      label: "供应商名称",
      sortable: true,
      thStyle: { width: "12rem" },
      width: "12rem",
      type: "short"
    },
    {
      key: 'BomID', label: 'Bom编号', sortable: true,
      type: "textarea",
      thStyle: {
        width: "10rem"
      }
    },
    {
      key: 'RouteID', label: '工艺路线编号', sortable: true,
      type: "textarea",
      thStyle: {
        width: "10rem"
      }
    },
    {
      key: 'TransportCost', label: '其他成本', sortable: true,
      type: "number",
      width: "200px",
      thStyle: {
        width: "10rem"
      }
    },
  ],
  detail_cost_fields: [
    {
      key: "AccountNum",
      label: "制造商编号",
      sortable: true,
      thStyle: {
        width: "6rem"
      }
    },
    {
      key: "AccountName",
      label: "制造商名称",
      sortable: true,
      thStyle: { width: "12rem" },
      width: "12rem",
      type: "short"
    },
    { key: 'TotalCost', label: '制造成本', sortable: true, type: "number", thStyle: { width: "8rem" }, },
    { key: 'TransportCost', label: '其他成本', sortable: true, type: "number", button: { type: "text" }, thStyle: { width: "8rem" }, },
    { key: 'TotalAllCost', label: '成本合计', sortable: true, type: "number", thStyle: { width: "8rem" }, },
    { key: 'PerCost', label: '单位成本', sortable: true, type: "number", thStyle: { width: "8rem" }, },
    { key: 'CostDetail', label: '成本详情', sortable: true, type: "button", button: { type: "text", icon_class: "iconfont icon-look" }, },
  ],
  detail_vend_price_fields: [
    {
      key: "AccountNum",
      label: "供应商编号",
      sortable: true,
      thStyle: {
        width: "6rem"
      }
    },
    {
      key: "SEI_Name",
      label: "供应商名称",
      sortable: true,
      thStyle: { width: "16rem" },
      width: "16rem",
      type: "short"
    },
    { key: 'Cost_Sum', label: '成本', sortable: true, type: "number", thStyle: { width: "8rem" }, },
    { key: 'AmountWOTax', label: '报价', sortable: true, type: "number", thStyle: { width: "8rem" }, },
  ],
  qth_distribution_price_fields: [
    {
      key: "AccountNum",
      label: "供应商编号",
      sortable: true,
      thStyle: {
        width: "6rem"
      }
    },
    {
      key: "AccountName",
      label: "供应商名称",
      sortable: true,
      thStyle: { width: "16rem" },
      width: "16rem",
      type: "short"
    },
    { key: 'TransportCost', label: '其他成本', sortable: true, type: "number", thStyle: { width: "6rem" }, },
    { key: 'TotalAllCost', label: '总成本', sortable: true, type: "number", thStyle: { width: "6rem" }, },
    { key: 'PerCost', label: '单位成本/报价', sortable: true, type: "number", thStyle: { width: "8rem" }, },
    { key: 'QuotationTaskNum', label: '报价申请编号', sortable: true, thStyle: { width: "125px" } },
    { key: 'ConsultQuoteNum', label: '询价单编号', sortable: true, thStyle: { width: "120px" } },
    { key: 'ConsultQuoteDetailNum', label: '询价单行号', sortable: true },
    { key: 'QuantityAmountFrom', label: '起始数量', sortable: true, type: "number", thStyle: { width: "5rem" }, },
    { key: 'QuantityAmountTo', label: '结束数量', sortable: true, type: "number", thStyle: { width: "5rem" }, },
    { key: 'DistributionRatio', label: '采购分配比例(%)', sortable: true },
    { key: 'DayOutQty', label: '每日产量', sortable: true },
    { key: 'DeliveryAddress', label: '交货地址', sortable: true },
    { key: 'DeliveryMode', label: '运输方式', sortable: true },
    { key: 'ConsultDes', label: '询价备注', sortable: true, },
    {
      key: 'VendAccessory',
      label: '供应商附件',
      type: "button",
      button: {
        type: "text",
        icon_class: "iconfont icon-fujian",
        label: "",
        show_label: true
      },
      thStyle: { width: "80px" }
    },
    // { key: 'CostDetail', label: '详情', sortable: true, type: "button", button: { type: "text" }, },
  ],
  qth_invent_price_fields: [
    {
      key: "AccountNum",
      label: "供应商编号",
      sortable: true,
      thStyle: {
        width: "5rem"
      }
    },
    {
      key: "AccountName",
      label: "供应商名称",
      sortable: true,
      thStyle: { width: "12rem" },
      width: "12rem",
      type: "short"
    },
    {
      key: 'BomID', label: 'Bom编号', sortable: true,
      type: "textarea",
      thStyle: {
        width: "10rem"
      }
    },
    {
      key: 'RouteID', label: '工艺路线编号', sortable: true,
      type: "textarea",
      thStyle: {
        width: "10rem"
      }
    },
    {
      key: 'InventPriceConfirmState', label: '物料价格已确认', sortable: true,
      type: "boolean",
      thStyle: {
        width: "6rem"
      }
    },
  ],

}

const dataForm = {}

///前端验证
const rules = {}
const methods = {
  ///计算工艺实物投入
  async execCalcRouteInventQty(_params) {
    let item_biz_data = new biz_data_helper.base_entity_helper(
      "calc_route_invent_qty", {}, {})
    let result = await item_biz_data.handlerScriptAction({
      params: _params
    }).run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  ///计算bom成本额
  async execCalcBomCost(_params) {
    let item_biz_data = new biz_data_helper.base_entity_helper(
      "calc_bom_cost", {}, {})
    let result = await item_biz_data
      .handlerScriptAction({
        params: _params
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  ///计算物料工序成本
  async execCalcRsrcCost(_params) {
    let item_biz_data = new biz_data_helper.base_entity_helper(
      "calc_rsrc_cost",
      {},
      {}
    )
    let result = await item_biz_data
      .handlerScriptAction({
        params: _params
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  ///获取报价申请明细-供应商报价
  async getDataDetailCost(_params) {
    let item_biz_data = new biz_data_helper.base_entity_helper("sPlant_QuotationTask_Detail_Cost", {}, {})
    let f = _.map(fields.detail_cost_fields, "key")
    f.push("id")
    f.push("ProductQty")
    f.push("BomCostData")
    f.push("CaclBomCostData")
    f.push("CaclRouteData")
    f.push("CalcRsrcCostData")
    f.push("CostGroupData")
    f.push("WrkCtrCostData")
    let result = await item_biz_data.selectAction({
      params: _params,
      fields: f
    }).run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  ///保存报价申请明细-供应商成本
  async saveDataDetailCost(params) {
    let item_biz_data = new biz_data_helper.base_entity_helper("sPlant_QuotationTask_Detail_Cost", {}, {})
    let _actions = []
    for (var k in params) {
      if (k == "add" && params[k].length > 0) {
        let del_biz_data = new biz_data_helper.base_entity_helper("delete_quotationtask_detail_cost", {}, {})
        _actions.push(
          del_biz_data.execAction({
            params: { QuotationTaskDetailId: params[k][0].QuotationTaskDetailId },
          }).action({})
        )
        _actions.push(
          item_biz_data.insertAction({
            params: params[k],
            fields: _.map(fields.default, "key")
          }).action({})
        )
      }
      else if (k == "edit") {
        _actions.push(
          item_biz_data.updateAction({
            params: params[k],
            fields: _.map(fields.default, "key")
          }).action({})
        )
      }
      else if (k == "valid") {
        _actions.push(
          item_biz_data.updateAction({
            params: params[k],
            fields: _.map(fields.default, "key")
          }).action({})
        )
      }
      else if (k == "delete") {
        _actions.push(
          item_biz_data.deleteAction({
            params: params[k],
            fields: _.map(fields.default, "key")
          }).action({})
        )
      }
      else if (k == "approved") {
        _actions.push(
          item_biz_data.approveAction({
            params: params[k],
            fields: _.map(fields.default, "key")
          }).action({})
        )
      }
    }
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      if (params.add && params.add.length > 0) {
        return result.data.BatchResult.Actions[1].Result.Data[0]
      }
      return result.data.BatchResult.Actions[0].Result.Data[0]
    } else {
      return null
    }
  },
  async getBomRouteCheck(params) {
    let item_biz_data = new biz_data_helper.base_entity_helper(
      "get_bom_and_route_check", {}, {})
    let result = await item_biz_data.execAction({
      params: params
    }).run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  }
}
export { biz_data, dataForm, fields, methods, rules }

